export default __webpack_public_path__ + "static/media/012-volcano.643a907b.svg";